import LanguageTag from '../components/LanguageTag'
import Arrow from '../images/arrow.svg'
import './ClinicCard.css'

export default function ClinicCard(props) {
    return (
        <div className = "clinic-card" style = {{width: '1200px', padding: '20px', maxWidth: '70vw', paddingBottom: '40px', backgroundColor: 'transparent'}}>
            <p style = {{fontSize: '24px'}}>{props.title}</p>
            <p style = {{color: 'var(--blue)'}}>{props.city}, {props.state}</p>
            <p style = {{fontSize: '12px', marginTop: '20px'}}>{props.services}</p>
            <div className = "language-tags" style = {{display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '20px'}}>
                {props.langs.map((lang) => (
                    <LanguageTag lang = {lang}/>
                ))}
            </div>
            <a class = "clinic-learn-more" href = {props.website} style = {{display: 'flex', textAlign: 'right', float: 'right', fontSize: '12px', marginTop: '10px', height: 'max-content'}}>
                <p>Learn more</p>
                <img src = {Arrow} style = {{width: '10px', height: '10px', marginLeft: '5px'}}/>
            </a>
            <div style = {{width: '100%', height: '2px', backgroundColor: 'grey', marginTop: '30px', borderRadius: '10px'}}></div>
        </div>
    )
}